import { useEffect, useState } from "react";
import { api, pct } from "../api";
import ExportBar from "../components/ExportBar";

export default function Projects() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/data/latest").then((r) => setData(r.data)); }, []);
  if (!data) return <div className="text-slate-500">Loading…</div>;
  if (data.empty) return <div className="bg-white p-8 rounded-xl text-center text-slate-500">No data.</div>;

  const rows = (data.projects || []).slice().sort((a, b) => b.avg - a.avg);
  return (
    <div data-testid="projects-page">
      <div className="flex items-start justify-between flex-wrap gap-3 mb-4">
        <h2 className="text-xl font-bold" style={{ color: "#1a3666" }}>Projects ({rows.length})</h2>
        <ExportBar spec={() => ({
          title: "Projects",
          filters: {},
          columns: [
            { key: "name", label: "Project" },
            { key: "team", label: "Team", get: (r) => r.employees.length },
            { key: "apr", label: "Apr %", get: (r) => pct((r.apr / r.employees.length) || 0) },
            { key: "may", label: "May %", get: (r) => pct((r.may / r.employees.length) || 0) },
            { key: "jun", label: "Jun %", get: (r) => pct((r.jun / r.employees.length) || 0) },
            { key: "avg", label: "Avg %", get: (r) => pct(r.avg) },
            { key: "members", label: "Members", get: (r) => r.employees.join(", ") },
          ],
          rows,
          filename: "vSDI_Projects",
        })} />
      </div>
      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-500 text-[11px] uppercase">
            <tr>
              <th className="px-3 py-2 text-left">Project</th>
              <th className="px-3 py-2 text-center">Team</th>
              <th className="px-3 py-2 text-center">Apr</th>
              <th className="px-3 py-2 text-center">May</th>
              <th className="px-3 py-2 text-center">Jun</th>
              <th className="px-3 py-2 text-center">Avg</th>
              <th className="px-3 py-2 text-left">Members</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((p) => (
              <tr key={p.name} className="border-t border-slate-100 hover:bg-slate-50">
                <td className="px-3 py-2 font-medium">{p.name}</td>
                <td className="px-3 py-2 text-center">{p.employees.length}</td>
                <td className="px-3 py-2 text-center">{pct(p.apr / p.employees.length || 0)}</td>
                <td className="px-3 py-2 text-center">{pct(p.may / p.employees.length || 0)}</td>
                <td className="px-3 py-2 text-center">{pct(p.jun / p.employees.length || 0)}</td>
                <td className="px-3 py-2 text-center font-semibold">{pct(p.avg)}</td>
                <td className="px-3 py-2 text-slate-500 text-xs">{p.employees.slice(0, 5).join(", ")}{p.employees.length > 5 ? `, +${p.employees.length - 5}` : ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
